export const tutorialAllowedPaths = ['/', '/comparison', '/room-offer']
